import { useQuery } from '@tanstack/react-query'
import OrgSyncService, {
  CloneTimelineReq,
  ValidateReq,
} from 'src/service/OrgSyncService'

export const useMigrateValidate = (data?: ValidateReq) => {
  return useQuery({
    queryKey: [
      'org',
      'migrate',
      'validate',
      data,
      data?.destination_project_id,
    ],
    queryFn: () => OrgSyncService.validateMigration(data),
    enabled: !!data,
  })
}

export const useCloneTimeline = (data: CloneTimelineReq | null) => {
  return useQuery({
    queryKey: ['org', 'migrate', 'cloneTimeline', data],
    queryFn: () => OrgSyncService.cloneTimeline(data as CloneTimelineReq),
    enabled: !!data,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
  })
}
